const METADATA_FILE = (environment, staticAssetsPrefix = '') => `${staticAssetsPrefix}/static-assets/${environment}gs-wrapper/metadata.json?random=${Math.ceil(Math.random() * 10000000)}`;
const GS_WRAPPER_URL = (artifact, version, staticAssetsPrefix = '') => `${staticAssetsPrefix}/static-assets/platform-assets/${artifact}/${version}/gs-wrapper.js`;
const GS_WRAPPER_ES6_URL = (artifact, version, staticAssetsPrefix = '') => `${staticAssetsPrefix}/static-assets/platform-assets/${artifact}/${version}/gs-wrapper.es6.js`;

const LoadWrapper = {
    load() {
        this.loadConfig();
    },
    loadConfig() {
        const req = new XMLHttpRequest();
        req.addEventListener('load', LoadWrapper.loadMetadata);
        req.addEventListener('error', LoadWrapper.onConfigError);
        req.open('GET', './config.json');
        req.send();
    },
    loadMetadata() {
        const data = JSON.parse(this.responseText);
        const search = window.location.search.match(/environment=([^&]*)/);
        const environment = search ? `${search[1]}/` : '';
        const req = new XMLHttpRequest();
        req.addEventListener('load', function () {
            LoadWrapper.onMetadataLoaded(JSON.parse(this.responseText), data.staticAssetsPrefix, data.cdnHost);
        });
        req.addEventListener('error', LoadWrapper.onMetadataError);
        req.open('GET', METADATA_FILE(environment, data.staticAssetsPrefix));
        req.send();
    },
    loadWrapper(wrapperUrl, buildInfo, staticAssetsPrefix, cdnHost, module = false) {
        const scriptElement = window.document.createElement('script');
        const { version } = buildInfo;
        const artifactId = buildInfo.artifactId.replace(/@.*\//, '');
        const type = module ? 'module' : 'text/javascript';
        if (!module) {
            scriptElement.setAttribute('nomodule', null);
        }
        scriptElement.setAttribute('id', 'gs-wrapper-script');
        scriptElement.setAttribute('data-staticAssetsPrefix', staticAssetsPrefix);
        scriptElement.setAttribute('data-cdnHost', cdnHost);
        scriptElement.setAttribute('type', type);
        scriptElement.setAttribute('src', wrapperUrl(artifactId, version, staticAssetsPrefix));
        scriptElement.onload = this.onWrapperLoaded;
        scriptElement.onerror = this.onWrapperError;
        window.document.body.appendChild(scriptElement);
    },
    onMetadataLoaded(data, staticAssetsPrefix = '', cdnHost = '') {
        LoadWrapper.loadWrapper(GS_WRAPPER_URL, data.buildInfo, staticAssetsPrefix, cdnHost);
        LoadWrapper.loadWrapper(GS_WRAPPER_ES6_URL, data.buildInfo, staticAssetsPrefix, cdnHost, true);
    },
    onConfigError(e) {
        console.warn('Could not load gs-wrapper config', e);
    },
    onMetadataError(e) {
        console.warn('Could not load gs-wrapper metadata', e);
    },
    onWrapperLoaded() {
        console.info('[LoadWrapper] - gs-wrapper loaded');
    },
    onWrapperError(e) {
        console.warn('Could not load gs-wrapper', e);
    }
};


/**
 * Safari 10.1 supports modules, but does not support the `nomodule` attribute - it will
 * load <script nomodule> anyway. This snippet solve this problem, but only for script
 * tags that load external code, e.g.: <script nomodule src="nomodule.js"></script>
 *
 * Again: this will **not** prevent inline script, e.g.:
 * <script nomodule>alert('no modules');</script>.
 *
 * This workaround is possible because Safari supports the non-standard 'beforeload' event.
 * This allows us to trap the module and nomodule load.
 *
 * Note also that `nomodule` is supported in later versions of Safari - it's just 10.1 that
 * omits this attribute.
 */
(() => {
    window.global = window;
    const check = document.createElement('script');
    if (!('noModule' in check) && 'onbeforeload' in check) {
        let support = false;
        document.addEventListener('beforeload', (e) => {
            if (e.target === check) {
                support = true;
            } else if (!e.target.hasAttribute('nomodule') || !support) {
                return;
            }
            e.preventDefault();
        }, true);

        check.type = 'module';
        check.src = '.';
        document.head.appendChild(check);
        check.remove();
    }
})();

LoadWrapper.load();
